<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>
import { fieldProps } from '@/composables/FieldComposable';

export default
{
    name: 'AbstractField',

    props: fieldProps,

    computed:
    {
        tabIndex()
        {
            return this.side === 'left' ? 2 : 1;
        },

        supplement()
        {
            if(this.parameter.priced_article_code)
            {
                const article = this.$store.getters['catalog/getByCode'](this.parameter.priced_article_code);
                if(article)
                {
                    return `+ ${this.max2decimals(article.price)} ${article.currency_code}`;
                }
            }

            return null;
        },

        formattedValue()
        {
            return this.format(this.modelValue);
        },
    },

    methods:
    {
        max2decimals(price)
        {
            return parseFloat(price).toFixed(2).replace(/\.0{0,2}$/, '');
        },

        format(value)
        {
            if(value === null)
            {
                return null;
            }

            return this.$pf(value, this.parameter.code, 'value');
        },
    },
};
</script>
